import type { Container } from 'pixi.js';
import { Signal } from 'typed-signals';
import { getLocalizedText } from '@softgames/localization';
import type { Popup } from '../../../popups/Popup';
import { RaceEventBigRankFlagLayout } from '../../../../layouts/raceEvent/RaceEventBigRankFlagLayout';
import { playLayoutAnimation } from '../../../libs/layouts/layoutAnimations/playLayoutAnimation';

export class RaceEventRankChangePopup implements Popup {
  public readonly onReadyForFlagTransfer = new Signal<(flagContainer: Container) => void>();

  private readonly layout = new RaceEventBigRankFlagLayout();

  public readonly root = this.layout.root;

  constructor(previous: number, current: number) {
    void this.play(previous, current);
  }

  private async play(previous: number, current: number): Promise<void> {
    const { redRankText, greenRankText } = this.layout;

    redRankText.text = getLocalizedText(this.toOrdinal(previous > current ? previous : current));
    greenRankText.text = getLocalizedText(this.toOrdinal(previous > current ? current : previous));

    await playLayoutAnimation(this.layout, previous > current ? 'Rank_Increase' : 'Rank_Decrease', false, (event) => {
      if (event === 'startTransition') {
        this.onReadyForFlagTransfer.emit(this.layout.flagContainer);
      }
    });
  }

  private toOrdinal(rank: number): string {
    if (rank === 1) return '1st';
    if (rank === 2) return '2nd';
    if (rank === 3) return '3rd';
    if (rank === 4) return '4th';
    if (rank === 5) return '5th';
    return `${rank}`;
  }
}
